<template>
  <el-input
    ref="input"
    :model-value="formattedPhone"
    @focus="handleFocus"
    @input="handleInput"
    @blur="formatOnBlur"
    @paste="handlePaste"
    placeholder="+7 (___) ___-__-__"
    maxlength="18"
  />
</template>

<script>
export default {
  props: {
    phone: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      internalValue: this.phone || '',
      isComplete: false
    }
  },
  computed: {
    formattedPhone() {
      return this.formatPhone(this.internalValue)
    }
  },
  watch: {
    phone(newValue) {
      this.internalValue = newValue
    }
  },
  methods: {
    focus() {
      // ref="input" у el-input!
      if (this.$refs.input && this.$refs.input.focus) {
        this.$refs.input.focus();  // Element Plus 2.x
      } else if (this.$refs.input && this.$refs.input.$el) {
        // fallback для старых версий/нестандартных обёрток
        const inp = this.$refs.input.$el.querySelector('input');
        if (inp) inp.focus();
      }
    },
    formatPhone(value) {
      let cleaned = ('' + value).replace(/\D/g, '');
      // Если номер начинается с 8 и длина >= 10 (стандартный мобильный)
      if (cleaned.length >= 11 && cleaned[0] === '8') {
        cleaned = '7' + cleaned.slice(1);
      }
      // если номер уже начинается с 7, ничего не делать
      let formatted = '+7';
      if (cleaned.length > 1) {
        formatted += ' (' + cleaned.substring(1, 4);
        if (cleaned.length > 4) {
          formatted += ') ' + cleaned.substring(4, 7);
          if (cleaned.length > 7) {
            formatted += '-' + cleaned.substring(7, 9);
            if (cleaned.length > 9) {
              formatted += '-' + cleaned.substring(9, 11);
            }
          }
        }
      }
      return formatted;
    },
    isValidPhone(value) {
      const cleaned = ('' + value).replace(/\D/g, '');
      return cleaned.length === 11;
    },
    handleFocus() {
      let cleaned = ('' + this.internalValue).replace(/\D/g, '');
      if (cleaned.startsWith('8')) {
        cleaned = '7' + cleaned.slice(1);
      }
      if (cleaned.startsWith('7')) {
        this.internalValue = '+7' + cleaned.slice(1);
      } else if (cleaned.length > 0) {
        this.internalValue = '+7' + cleaned;
      } else {
        this.internalValue = '+7';
      }
    },
    handleInput(event) {
      this.internalValue = event;
      const formatted = this.formatPhone(event); // Форматируем номер
      this.$emit('update:phone', formatted); // Передаем отформатированный номер
      this.isComplete = this.isValidPhone(formatted); // Проверяем отформатированный номер
      this.$emit('is-complete', this.isComplete);
    },
    formatOnBlur() {
      this.internalValue = this.internalValue.trim()
    },
    handlePaste(e){
      // Получить текст из буфера обмена
      const pasted = (e.clipboardData || window.clipboardData).getData('text');
      // Форматировать и записать
      this.internalValue = this.formatPhone(pasted);
      // Обновить родителю
      this.$emit('update:phone', this.internalValue);
      e.preventDefault();
    }
  }
}
</script>
